import { Euler, Quaternion, Vector2, Vector3 } from 'three';
import { ResourcesManager, TextComponent, Tween, Viewer, ViewerModule } from '@verybigthings/vbt-webvr-framework';
export default class ScalesBowlModule extends ViewerModule {
    constructor(model, table, uiContainer, parentLevel) {
        super();
        // public __inited: boolean = false;
        this.maxSaltWeight = 0;
        this.uiObject.name = 'ScalesBowlModule';
        this.model = model;
        this.table = table;
        this.parentLevel = parentLevel;
        this.uiContainer = uiContainer;
        this.defaultPosition = model.position.clone();
        this.saltMountJar = model.getObjectByName('salt_mount_jar');
        this.saltMountJar.scale.set(0.01, 0.01, 0.01);
        this.saltMountJar.geometry.translate(this.saltMountJar.position.x, this.saltMountJar.position.y, this.saltMountJar.position.z);
        this.saltMountJar.position.set(0, 0, 0);
        this.addObject(this.scaleDisplay = new TextComponent({
            size: new Vector2(1.65, 1.65),
            pxSize: new Vector2(256, 256).multiplyScalar(window['quality'] === 'very low' ? 0.4 : 1),
            text: {
                style: { size: `${30 * (window['quality'] === 'very low' ? 0.4 : 1)}px`, family: 'Nunito', weight: '400', color: 'white' },
                lineHeight: 28 * (window['quality'] === 'very low' ? 0.4 : 1),
                value: ' 0.0g',
                autoWrappingHorizontal: true,
                align: 'right',
                autoWrapping: true,
                margin: {
                    bottom: 10 * (window['quality'] === 'very low' ? 0.4 : 1),
                    top: 5 * (window['quality'] === 'very low' ? 0.4 : 1)
                }
            },
            background: { color: 'black' }
        }));
        this.scaleDisplay.uiObject.name = 'scaleDisplay';
        this.scaleDisplay.uiObject.position.set(-2.6, -3.71, 0.87);
        this.scaleDisplay.uiObject.rotateX(-1.39);
        this.scaleDisplay.uiObject.scale.multiplyScalar(1.77);
        this.scaleDisplay.uiObject.visible = false;
    }
    getWeight() {
        return this.maxSaltWeight;
    }
    startPourFromJar() {
        this.scaleDisplay.uiObject.visible = true;
    }
    plusMass(newMass) {
        const currScale = newMass / 5.8;
        this.saltMountJar.scale.set(currScale, currScale, currScale);
        this.scaleDisplay.setText('' + newMass.toFixed(1) + 'g');
        this.maxSaltWeight = newMass;
    }
    pourIntoFlask(onComplete) {
        ResourcesManager.getAudioManger().getAudio('sand_full_sound').play();
        Viewer.pointerController.setObject(null);
        this.table.add(this.model);
        this.model.position.set(0.3, 6, 1.64);
        const flaskSalt = this.table.getObjectByName('salt_mount_flask');
        this.rotateTo(new Euler(0, 0, 1.1), 800, 0, onComplete);
        const endFlaskSaltScale = this.saltMountJar.scale.clone();
        new Tween(this.saltMountJar.scale)
            .to(new Vector3(0.01, 0.01, 0.01), 800)
            .easing(TWEEN.Easing.Linear.None)
            .start();
        new Tween(flaskSalt.scale)
            .to(endFlaskSaltScale, 800)
            .easing(TWEEN.Easing.Linear.None)
            .start();
    }
    setToPointerController() {
        Viewer.pointerController.setObject(this.model);
    }
    flyTo(pos, time = 600, delay = 0, onComplete) {
        new Tween(this.model.position)
            .to(pos.clone(), time)
            .easing(TWEEN.Easing.Linear.None)
            .onComplete(() => onComplete && onComplete())
            .delay(delay)
            .start();
    }
    setDefaultPositionRotation(onComplete) {
        const delay = 300;
        this.flyTo(this.defaultPosition, 600, delay, onComplete);
        this.rotateTo(new Euler(), 600, delay);
    }
    rotateTo(newEuler, time = 600, delay = 0, onComplete) {
        const oldQuaternion = this.model.quaternion.clone();
        const newQuaternion = new Quaternion().setFromEuler(newEuler);
        new Tween({ alpha: 0 })
            .to({ alpha: 1 }, time)
            .easing(TWEEN.Easing.Linear.None)
            .onUpdate((alpha) => {
            const quat = oldQuaternion.clone().slerp(newQuaternion.clone(), alpha);
            this.model.quaternion.copy(quat);
        })
            .onComplete(() => this.setDefaultPositionRotation(onComplete))
            .delay(delay)
            .start();
    }
    clearWeight() {
        this.scaleDisplay.setText(' 0.0g');
    }
    show(isVisible = true) {
        this.uiObject.visible = isVisible;
    }
}
